import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getFormaPagoLabel } from '../../../../utils/formaPagoLabel';

const publicUrl = process.env.PUBLIC_URL || '';
const logo = `${publicUrl.replace(/\/$/, '')}/logoportena.png`;

/** Teléfono del cliente (alias cliente_telefono en API para no pisarlo con d.*) */
const telefonoClientePedido = (pedido) => {
  const v = pedido?.cliente_telefono ?? pedido?.cli_telefono;
  if (v == null || String(v).trim() === '') return '-';
  return String(v).trim();
};

const obtenerLogoSiEstaEnCache = () => {
  const img = new Image();
  img.src = logo;

  return img.complete && img.naturalWidth > 0 ? img : null;
};

const dibujarProductosSolicitados = (doc, pedido, yPos) => {
  const texto = pedido?.ped_productos_solicitados?.trim();
  if (!texto) return yPos;

  yPos += 12;
  if (yPos > 250) {
    doc.addPage();
    yPos = 20;
  }

  doc.setFont(undefined, 'bold');
  doc.setFontSize(11);
  doc.setTextColor(33);
  doc.text('Productos solicitados (artículos que no existían en el carrito):', 14, yPos);
  yPos += 7;
  doc.setFont(undefined, 'normal');
  const lineas = doc.splitTextToSize(texto, 180);
  doc.text(lineas, 14, yPos);
  return yPos + lineas.length * 6;
};

const formatearCantidad = (detalle) => {
  const cantidadNum = parseFloat(detalle.dpe_cantidad) || 0;
  const tipoUnidadNombre = detalle.tipo_unidad_nombre || 'Entero';
  const contenidoNeto = detalle.contenido_neto ? parseFloat(detalle.contenido_neto) : null;
  const unidadMedida = (detalle.ums_nombre || '').toLowerCase().trim();
  const nombreArticulo = (detalle.aem_nombre || '').toLowerCase();

  const esFraccionado = tipoUnidadNombre.toLowerCase() === 'fraccionado' && contenidoNeto;
  const nombreIndicaKilo = nombreArticulo.includes('kg') ||
    nombreArticulo.includes('kilo') ||
    nombreArticulo.includes('x kg') ||
    nombreArticulo.includes('por kg');

  if (!esFraccionado && !nombreIndicaKilo) {
    return cantidadNum.toString();
  }

  let esGramos = false;
  let esKilos = false;

  if (esFraccionado && unidadMedida) {
    esGramos = (
      unidadMedida.includes('gramo') ||
      unidadMedida === 'g' ||
      unidadMedida === 'gr' ||
      unidadMedida === 'gramos'
    ) && !unidadMedida.includes('kilo');

    esKilos = (
      unidadMedida.includes('kilo') ||
      unidadMedida === 'kg' ||
      unidadMedida === 'kilogramo' ||
      unidadMedida === 'kilogramos'
    );
  }

  const probableGramos = !unidadMedida && cantidadNum >= 100;
  const probableKilos = !unidadMedida && cantidadNum < 10 && cantidadNum > 0;

  let cantidadEnKilos;
  if (esGramos || probableGramos || (nombreIndicaKilo && cantidadNum >= 100)) {
    cantidadEnKilos = cantidadNum / 1000;
  } else if (esKilos || probableKilos || (nombreIndicaKilo && cantidadNum < 10 && cantidadNum > 0)) {
    cantidadEnKilos = cantidadNum;
  } else if (nombreIndicaKilo && cantidadNum >= 100) {
    cantidadEnKilos = cantidadNum / 1000;
  } else {
    cantidadEnKilos = cantidadNum;
  }

  const cantidadFormateada = cantidadEnKilos >= 1
    ? cantidadEnKilos.toFixed(1)
    : cantidadEnKilos.toFixed(2);

  return `${cantidadFormateada} kg`;
};

export const CGenerarPDF = (pedido, tipoPagos, onFinish) => {
  try {
    if (!pedido || !Array.isArray(pedido.detalles) || pedido.detalles.length === 0) {
      console.error('ERROR: Pedido o detalles no válidos', pedido);
      return;
    }

    const doc = new jsPDF();
    const fecha = new Date(pedido.ped_fecha).toLocaleString();
    const formaPagoStr = getFormaPagoLabel(pedido, tipoPagos || []);
    const logoImg = obtenerLogoSiEstaEnCache();
    let y = 43;

    doc.setFontSize(18);
    doc.setTextColor(40);
    doc.setFont(undefined, 'bold');
    doc.setDrawColor(200);
    doc.setLineWidth(0.5);

    if (logoImg) {
      try {
        doc.addImage(logoImg, 'PNG', 80, 10, 50, 30);
        doc.text('Comercial Porteña', 105, 45, { align: 'center' });
        doc.line(14, 50, 196, 50);
        doc.setFontSize(16);
        doc.text('Detalle del Pedido', 14, 60);
        y = 68;
      } catch (error) {
        console.warn('No se pudo agregar el logo al PDF:', error);
        doc.setFontSize(18);
        doc.text('Comercial Porteña', 105, 20, { align: 'center' });
        doc.line(14, 25, 196, 25);
        doc.setFontSize(16);
        doc.text('Detalle del Pedido', 14, 35);
      }
    } else {
      doc.text('Comercial Porteña', 105, 20, { align: 'center' });
      doc.line(14, 25, 196, 25);
      doc.setFontSize(16);
      doc.text('Detalle del Pedido', 14, 35);
    }

    doc.setFontSize(12);
    doc.setTextColor(33);
    doc.setFont(undefined, 'normal');

    const lineHeight = 7;
    const texto = [
      `Fecha: ${fecha}`,
      `Cliente: ${pedido.cli_nombre || '-'}`,
      `Telefono: ${telefonoClientePedido(pedido)}`,
      `Dirección: ${pedido.dci_direccion || '-'}`,
      `Localidad: ${pedido.dci_localidad || '-'}`,
      `Código Postal: ${pedido.dci_codigoposta || '-'}`,
      pedido.dci_observacion ? `Observación: ${pedido.dci_observacion}` : null,
      pedido.ped_observaciones ? `Observaciones del Pedido: ${pedido.ped_observaciones}` : null,
      `Forma de pago: ${formaPagoStr}`,
      `Tipo de envío: ${pedido.ped_tipoenvio === 2 ? 'Retiro en local' : 'Envío a domicilio'}`
    ].filter(Boolean);

    texto.forEach(t => {
      const lineas = doc.splitTextToSize(t, 180);
      doc.text(lineas, 14, y);
      y += lineHeight * lineas.length;
    });

    autoTable(doc, {
      startY: y + 5,
      head: [['SKU', 'Artículo', 'Cantidad', 'Total']],
      body: pedido.detalles.map(d => [
        d.aem_sku || '-',
        d.aem_nombre || '-',
        formatearCantidad(d),
        `$${Number(d.dpe_total || 0).toFixed(2)}`
      ]),
      theme: 'grid',
      headStyles: {
        fillColor: [33, 150, 243],
        textColor: 255,
        halign: 'center'
      },
      styles: { fontSize: 10 },
      columnStyles: {
        0: { cellWidth: 28 },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 28, halign: 'center' },
        3: { cellWidth: 32, halign: 'right' }
      }
    });

    const subtotalProductos = pedido.detalles.reduce((sum, item) => {
      return sum + parseFloat(item.dpe_total || 0);
    }, 0);

    const costoEnvio = (pedido.ped_tipoenvio !== 2 && pedido.ped_direccion && pedido.ped_direccion !== 0)
      ? parseFloat(pedido.suc_costoenvio || 0)
      : 0;

    let yPos = doc.lastAutoTable.finalY + 10;

    doc.setFont(undefined, 'normal');
    doc.setFontSize(11);
    doc.text(`Subtotal: $${subtotalProductos.toFixed(2)}`, 14, yPos);
    yPos += 7;

    if (costoEnvio > 0) {
      doc.text(`Costo de envío: $${costoEnvio.toFixed(2)}`, 14, yPos);
      yPos += 7;
    }

    doc.setFont(undefined, 'bold');
    doc.setFontSize(12);
    doc.text(`TOTAL: $${Number(pedido.ped_total || 0).toFixed(2)}`, 14, yPos);

    dibujarProductosSolicitados(doc, pedido, yPos);

    doc.setFontSize(10);
    doc.setTextColor(150);
    doc.setFont(undefined, 'normal');
    doc.text(`Pedido N° ${pedido.ped_id} - Gracias por su compra`, 14, 285);

    doc.save(`pedido_${pedido.ped_id}.pdf`);
  } catch (error) {
    console.error('Error al generar PDF:', error);
  } finally {
    if (onFinish) onFinish();
  }
};
